export default "__VITE_ASSET__BdtWxoat__"